import React from 'react';

export const Hero = () => (
  <div className="container mx-auto pt-6">
    <h1 className="text-4xl md:text-5xl text-[#0C0D1A] font-semibold mb-6">
      Toolkit Enquiry Form
    </h1>

    <div className="text-base text-[#373945] font-450 xl:w-[60rem]">
      <p className="mb-8">
        Registered advisers have access to our marketing toolkit resources, designed to help you grow your business. Log into your account below to access the toolkit enquiry form.
      </p>
      <p>
        Not registered with us yet? No problem, simply use our online registration form and register today.
      </p>
    </div>
  </div>
);
